import React, { useCallback, useState } from 'react'
import { usePermissionChecker } from '@/hooks/usePermissionChecker'
import { useLocalization } from '@/hooks/localization'
import { Button } from '@/components/button'
import context from '@/context'
import { openErrorDialog } from '@/utils/dialogHelpers'

function RestartWorkflowButton ({ ticketId, onRestart }) {
  const isGranted = usePermissionChecker()
  const { localize } = useLocalization()
  const granted = isGranted('CanRestartWorkflow')

  const [loading, setLoading] = useState(false)
  const handleClick = useCallback(() => {
    setLoading(true)
    context.api.ticketService.restartTicket(ticketId)
      .then(onRestart)
      .finally(() => setLoading(false))
      .catch(openErrorDialog)
  }, [onRestart, ticketId])

  return granted ? <Button className='btn btn-danger'
    onClick={handleClick}
    icon={loading ? 'loader bx-spin' : 'revision'}
    confirmTitle={'Common:Restart'}
    confirmText={'Common:RestartConfirmation'}
    disabled={loading}>
    {localize('Common:Restart')}
  </Button> : null
}

export { RestartWorkflowButton }



// WEBPACK FOOTER //
// ./src/internal-app/pages/tickets/restartWorkflowButton.js